var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-16 flex flex-col items-stretch text-center"},[_c('h2',{staticClass:"text-2xl md:text-4xl"},[_vm._v("Send inn et tilbud")]),_c('CustomOfferForm'),_c('hr',{staticClass:"border my-4"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }